import type { AlgonomyPlacement, AlgonomyProduct } from './Loader';

export interface AlgonomyOutfit {
  title: string;
  items: AlgonomyProduct[];
}

export interface AlgonomyOutfitPlacement extends AlgonomyPlacement {
  outfits?: { title?: string; message?: string; items?: AlgonomyProduct[] }[];
}

export const getOutfitsFromPlacement = (
  placement?: AlgonomyOutfitPlacement | null
): AlgonomyOutfit[] => {
  if (!placement) return [];

  const groups =
    placement.outfits ??
    (placement as { groups?: AlgonomyOutfitPlacement['outfits'] }).groups;

  if (Array.isArray(groups) && groups.length > 0) {
    return groups
      .map((group) => ({
        title: group.title ?? group.message ?? '',
        items: Array.isArray(group.items) ? group.items : [],
      }))
      .filter((outfit) => outfit.items.length > 0);
  }

  if (Array.isArray(placement.items) && placement.items.length > 0) {
    return [{ title: placement.message ?? '', items: placement.items }];
  }

  return [];
};

export default getOutfitsFromPlacement;
